export enum DebtStageEnum {
    Mixed = 'Mixed',
    Trial = 'Trial',
    PreTrial = 'PreTrial',
}
